export default {"src":"/_next/static/media/melting.755346a6.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};